<script setup lang="ts">
interface Props {
  ui?: {
    base?: string
    header?: { base?: string; padding?: string }
    body?: { base?: string; padding?: string }
    footer?: { base?: string; padding?: string }
  }
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  ui: () => ({})
})
</script>

<template>
  <div
    class="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden"
    :class="[props.ui?.base, $props.class]"
  >
    <div
      v-if="$slots.header"
      class="px-4 py-3 sm:px-6 border-b border-gray-200"
      :class="[props.ui?.header?.base, props.ui?.header?.padding]"
    >
      <slot name="header" />
    </div>
    <div
      class="p-4 sm:p-6"
      :class="[props.ui?.body?.base, props.ui?.body?.padding]"
    >
      <slot />
    </div>
    <div
      v-if="$slots.footer"
      class="px-4 py-3 sm:px-6 border-t border-gray-200 bg-gray-50"
      :class="[props.ui?.footer?.base, props.ui?.footer?.padding]"
    >
      <slot name="footer" />
    </div>
  </div>
</template>
